module.exports = __webpack_public_path__ + "static/media/archive-book-yellow.9bb79548.svg";